module.exports = __webpack_public_path__ + "static/img/new10-Tg2vNs9U.56baaf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/new10-Tg2vNs9U.png
// module id = FLXF
// module chunks = 16